module.exports = __webpack_public_path__ + "static/media/slow-smile-animated.18bbe284.gif";